import angular from "angular";
import BlndTable from "app/common/table";

import addModalTpl from "./templates/add.modal.html";
import editModalTpl from "./templates/edit.modal.html";
import deleteModal from "./templates/delete.modal.html";

class EditHitPercentageModalCtrl {
  constructor(R, $uibModalInstance, $state, object) {
    "ngInject";
    this.object = object;
    this.R = R;
    this.data = this.R.copy(object);
    this.$state = $state;
    this.$modal = $uibModalInstance;
  }

  get title() {
    return `Hit percentage: ${this.object.name}`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    let self = this;
    this.data
      .put()
      .then(
        function (data) {
          angular.extend(self.object, data);
          self.$state.go("r.in.top.admin.hit_percentages.list", {
            reload: true,
          });
          self.$modal.close(data.id);
        },
        function (resp) {
          self.errors = resp.data;
        },
        self.$state.reload()
      )
      .finally(() => (self.loading = false));
  }
}

export class HitPercentageListCtrl {
  constructor(
    NgTableParams,
    Modal,
    $growl,
    $state,
    $stateParams,
    HitPercentageStore
  ) {
    "ngInject";

    this.Modal = Modal;
    this.$growl = $growl;
    this.$state = $state;
    this.selectedObject = $stateParams.objectId;

    this.defaultParams = {
      page_size: 20,
    };

    this.resetParams();

    this.table = new BlndTable(NgTableParams, HitPercentageStore, {
      defaultParams: this.defaultParams,
      params: this.params,
    });

    if ($state.params && $state.params.objectId) {
      this.selectedObject = $state.params.objectId;
    }
  }

  addHitPercentage() {
    let self = this;
    let $modal = this.Modal.open({
      template: addModalTpl,
      controller: CreateHitPercentageCtrl,
    });

    $modal.result.then(function (objectId) {
      self.$growl.added();
      self.$state.go("r.in.top.admin.hit_percentages.list.hit_percentage", {
        objectId: objectId,
      });
      self.$state.reload();
    });
  }

  selectRow(objectId) {
    this.selectedObject = objectId;
    this.$state.go("r.in.top.admin.hit_percentages.list.hit_percentage", {
      objectId: objectId,
    });
  }

  resetParams() {
    this.params = _.clone(this.defaultParams);
  }

  refresh() {
    return this.table.refresh(this.params);
  }
}

class CreateHitPercentageCtrl {
  constructor($uibModalInstance, HitPercentageStore) {
    "ngInject";

    this.$modal = $uibModalInstance;
    this.store = HitPercentageStore;
    this.data = {
      is_active: false,
    };
  }

  get title() {
    return `Create new hit percentage`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    let self = this;
    self.loading = true;
    this.store
      .create(this.data)
      .then(
        function (data) {
          self.$modal.close(data.id);
        },
        function (resp) {
          self.errors = resp.data;
        }
      )
      .finally(() => (self.loading = false));
  }
}

class DeleteHitPercentageCtrl {
  constructor(R, $uibModalInstance, $state, object) {
    "ngInject";
    this.object = object;
    this.R = R;
    this.data = this.R.copy(object);
    this.$state = $state;
    this.$modal = $uibModalInstance;
  }

  get title() {
    return `Delete hit percentage ${this.object.rate_pct}%?`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    let self = this;
    let old_data = this.R.copy(this.data);
    this.data
      .remove()
      .then(
        function (data) {
          angular.extend(self.object, data);
          self.$state.go("r.in.top.admin.hit_percentages.list", {
            reload: true,
          });
          self.$modal.close(old_data.id);
        },
        function (resp) {
          self.errors = resp.data;
        },
        self.$state.reload()
      )
      .finally(() => (self.loading = false));
  }
}

export class HitPercentageCtrl {
  constructor($rootScope, Modal, $growl, $object) {
    "ngInject";
    this.object = $object;
    this.$growl = $growl;
    this.Modal = Modal;
    $rootScope.object = this.object;
  }

  editModal() {
    let self = this;
    let $modal = this.Modal.open({
      template: editModalTpl,
      controller: EditHitPercentageModalCtrl,
      resolve: {
        object: () => self.object,
      },
    });

    $modal.result.then(function () {
      self.$growl.updated();
    });
  }

  deleteModal() {
    let self = this;
    let $modal = this.Modal.open({
      template: deleteModal,
      controller: DeleteHitPercentageCtrl,
      resolve: {
        object: () => self.object,
      },
    });

    $modal.result.then(function () {
      self.$growl.updated();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/hit_percentages/ctrls.js